import i18n from "../../i18n";

const tSg = (key: string, opts?: Record<string, unknown>) =>
  i18n.t(key, { ns: "sg", ...opts }) as string;

const DIVISIONS: { amount: number; one: string; many: string }[] = [
  { amount: 60, one: "second", many: "seconds" },
  { amount: 60, one: "minute", many: "minutes" },
  { amount: 24, one: "hour", many: "hours" },
  { amount: 30, one: "day", many: "days" },
  { amount: 12, one: "month", many: "months" },
  { amount: Number.POSITIVE_INFINITY, one: "year", many: "years" },
];

export function timeAgo(value: string | number | null | undefined): string {
  if (!value) return tSg("time.none");
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return tSg("time.none");

  let duration = (date.getTime() - Date.now()) / 1000;
  const past = duration <= 0;
  duration = Math.abs(duration);

  for (const { amount, one, many } of DIVISIONS) {
    if (duration < amount) {
      const n = Math.round(duration);
      const unit = tSg(`time.${n === 1 ? one : many}`);
      return tSg(past ? "time.ago" : "time.in", { n, unit });
    }
    duration /= amount;
  }
  return tSg("time.none");
}

export function fullName(o: {
  first_name?: string | null;
  last_name?: string | null;
}): string {
  return [o?.first_name, o?.last_name].filter(Boolean).join(" ") || "—";
}

export function connStatus(
  value: string | number | null | undefined
): "green" | "yellow" | "red" | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const hours = (Date.now() - date.getTime()) / 3_600_000;
  if (hours < 1) return "green";
  if (hours < 2) return "yellow";
  return "red";
}
